/**
 * DraftingAccessPane - who this document belongs to, as a pane body.
 *
 * A drafted document has no collaborator model on the backend yet, so the
 * honest answer to "who has this" is its MATTER LINKAGE: a draft attached to
 * a matter is visible to, and part of, that matter's work. The linkage badges
 * were inline in the page header (`DraftingAttachments`), where three linked
 * matters wrapped the header onto two lines and pushed the reading-mode
 * toggle off a laptop; they are the pane's content now - as a list of rows,
 * not a strip of pills.
 *
 * The explanatory line is the EMPTY STATE's, not the pane's: it is what
 * someone with no linkage needs, and dead weight above a list that already
 * answers the question. `DraftingAttachments` owns both.
 *
 * When a collaborator model does arrive, it joins this pane rather than
 * displacing it - which is why the pane is `access`, not `matters`.
 */

import React from 'react';
import PaneBody from '../../shared/surface/PaneBody';
import DraftingAttachments from '../DraftingAttachments';
import type { DraftingItem } from '../../../store/slices/draftingSlice';

interface Props {
  item: DraftingItem;
}

const DraftingAccessPane: React.FC<Props> = ({ item }) => (
  <PaneBody>
    <div className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden custom-scrollbar-main px-3 py-3">
      <DraftingAttachments item={item} />
    </div>
  </PaneBody>
);

export default DraftingAccessPane;
